import React from 'react'
import SideBar from "../../components/AdminDashboard/SideBar";
import AddPost from '../../components/AdminDashboard/AddAdvertsPost';
import { Link, Router } from 'react-router-dom';
function AddAvertsPage() { 
  return (
  <div className="admin_history">
      <div className="sidebar_container flex">
        <SideBar />
  
      </div>
      <div>
<Link to={"/ads"}>
      <div className='mt-20 mb-10 ml-20 text-[24px] font-semibold flex' > <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 10.9993H7.14L10.77 6.6393C10.9397 6.43508 11.0214 6.1718 10.997 5.90738C10.9726 5.64295 10.8442 5.39904 10.64 5.2293C10.4358 5.05956 10.1725 4.9779 9.90808 5.00228C9.64365 5.02666 9.39974 5.15508 9.23 5.3593L4.23 11.3593C4.19568 11.4066 4.16556 11.4568 4.14 11.5093C4.14 11.5593 4.14 11.5893 4.07 11.6393C4.02467 11.754 4.00094 11.876 4 11.9993C4.00094 12.1226 4.02467 12.2446 4.07 12.3593C4.07 12.4093 4.07 12.4393 4.14 12.4893C4.16556 12.5418 4.19568 12.592 4.23 12.6393L9.23 18.6393C9.32402 18.7522 9.44176 18.843 9.57485 18.9052C9.70793 18.9674 9.85309 18.9995 10 18.9993C10.2337 18.9998 10.4601 18.9184 10.64 18.7693C10.7413 18.6854 10.825 18.5822 10.8863 18.4659C10.9477 18.3496 10.9855 18.2222 10.9975 18.0913C11.0096 17.9603 10.9957 17.8282 10.9567 17.7026C10.9176 17.577 10.8542 17.4603 10.77 17.3593L7.14 12.9993H19C19.2652 12.9993 19.5196 12.8939 19.7071 12.7064C19.8946 12.5189 20 12.2645 20 11.9993C20 11.7341 19.8946 11.4797 19.7071 11.2922C19.5196 11.1047 19.2652 10.9993 19 10.9993Z" fill="#101828"/>
</svg>
 Add New Post / News</div>
</Link>

     <div>
        
        <AddPost/>
      </div>
      </div>
  

    </div> 
     )
}

export default AddAvertsPage